export default __webpack_public_path__ + "media/images/home/slide_ninki_lg-a98d2e8aba1d70cad07b277b9c4184ea.png";